import React, { useState } from 'react';
import CircleButton, { getCircleButtonClass, } from 'components/v2/buttons/CircleButton';
import { FileCheck } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '@cargomatic/ui';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import StopArrivedModal from 'components/modules/shipments/stops/StopArrivedModal';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
export default function StopArrivalNextStep({ item, shipment }) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const { stops } = shipment;
    const stop = stops.find((s) => { var _a; return s._id === ((_a = item === null || item === void 0 ? void 0 : item.meta) === null || _a === void 0 ? void 0 : _a.stop); });
    const createAction = () => {
        const offsite = (stop === null || stop === void 0 ? void 0 : stop.off_site) ? '_OFFSITE' : '';
        const empty = (stop === null || stop === void 0 ? void 0 : stop.empty) ? '_EMPTY' : '';
        const action = (stop === null || stop === void 0 ? void 0 : stop.action) === 'deliver' ? '_DELIVERY' : '_PICKUP';
        return `COMPLETE${offsite}${empty}${action}_ARRIVAL`;
    };
    const renderIcon = () => {
        return !item.complete ? (React.createElement(FileCheck, { className: "w-5 h-5" })) : (React.createElement("div", { "data-testid": "div-902a90ce", className: getCircleButtonClass({ size: 'small', color: 'brand' }) },
            React.createElement(CheckIcon, null)));
    };
    const renderArriveButton = (item, stops, shipper) => {
        if (!(item && stops && shipper)) {
            return null;
        }
        const circleButton = (shouldDisable) => (React.createElement(CircleButton, { dataTestId: "CircleButton-09a7e3e8", size: "small", disabled: shouldDisable, onClick: () => setShowModal(true) }, renderIcon()));
        if (item.complete) {
            return circleButton(true);
        }
        const disabled = !!item.disabled;
        if (disabled) {
            return (React.createElement(TooltipProvider, null,
                React.createElement(Tooltip, null,
                    React.createElement(TooltipTrigger, { asChild: true },
                        React.createElement("span", null, circleButton(disabled))),
                    React.createElement(TooltipContent, { side: "top" }, t('COMPLETE_PREVIOUS_STOPS')))));
        }
        return circleButton(false);
    };
    return (React.createElement("div", { "data-testid": "div-2e8587b0" },
        React.createElement("div", { "data-testid": "div-7021fc58", className: "flex justify-between text-sm text-gray-700  py-1 items-center" },
            React.createElement("span", { "data-testid": "span-6a57bdc0" }, t(createAction())),
            renderArriveButton(item, stops, shipment === null || shipment === void 0 ? void 0 : shipment.shipper)),
        showModal && (React.createElement(StopArrivedModal, { stop: stop, shipment: shipment, show: showModal, onHide: () => setShowModal(false), onStopArrived: ShipmentsActionCreators.transitionStop }))));
}
